import "./App.css";
import axios from "axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ClientPage } from "./pages/client/ClientPage";
import { HomePage } from "./pages/client/HomePage";
import { ProductList } from "./pages/client/ProductList";
import { ProductDetail } from "./pages/client/ProductDetail";
import { CartPage } from "./pages/client/CartPage";
import { Checkout } from "./pages/client/Checkout";
import { ContactPage } from "./pages/client/ContactPage";
import { PostList } from "./pages/client/PostList";
import { PostDetail } from "./pages/client/PostDetail";
import { LoginPage } from "./pages/client/LoginPage";
import { WishList } from "./pages/client/WishList";
import { AddressesPage } from "./pages/client/AddressesPage";
import { SignupPage } from "./pages/client/SignupPage";
import { GoogleCallback } from "./pages/client/GoogleCallback";
import { OrderSuccess } from "./pages/client/OrderSuccess";
import { NotFoundPage } from "./pages/client/NotFoundPage";

axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "*/*";
axios.defaults.headers.post["Access-Control-Allow-Origin"] =
  process.env.REACT_APP_CLIENT_URL || "*";
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
axios.defaults.headers["Shop-Domain"] = process.env.REACT_APP_SHOP_DOMAIN_URL;

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<ClientPage />}>
          <Route index element={<HomePage />} />
          {/* <Route path="/product" element={<ProductList />} />
          <Route path="/product/:id" element={<ProductDetail />} /> */}
          <Route path="/lien-he" element={<ContactPage />} />
          <Route path="/san-pham" element={<ProductList />} />
          <Route path="/san-pham/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/tin-tuc" element={<PostList />} />
          <Route path="/tin-tuc/:id" element={<PostDetail />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/wishlist" element={<WishList />} />
          <Route path="/addresses" element={<AddressesPage />} />
          <Route path="/signup" element={<SignupPage />} />

          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/auth/google/callback" element={<GoogleCallback />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
